module.exports = __webpack_public_path__ + "media/images/education/avatar-eniko-3f738fe3b3c8d8ae56ceae735bc01a68.png";